
  var rt = require("@stylable/runtime/dist/css-runtime-stylesheet.js");

  module.exports = rt.create(
      "TimePickerStepper2251188822",
      {"classes":{"root":"TimePickerStepper2251188822__root","controller":"TimePickerStepper2251188822__controller","nativeInput":"TimePickerStepper2251188822__nativeInput"},"vars":{},"stVars":{"textFont":"var(--textFont, var(--font_1))","borderRadius":"var(--borderRadius, 0px)","inputAlign":"var(--inputAlign)","inputPaddingStart":"var(--inputPadding_start, 0)","inputPaddingEnd":"var(--inputPadding_end, 0)"},"keyframes":{},"layers":{}},
      "",
      -1,
      module.id
  );
  